export default __webpack_public_path__ + "static/media/43t.249e5271.jpg";